import {Controller} from "@hotwired/stimulus"
import {startIcons} from "../import_lucid.js" // Import from your local file

export default class extends Controller {
  connect() {
    startIcons(this.element)
  }
}
